"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/avatar/style/index.js
// module id = 470
// module chunks = 1